import { useContext } from "react";
import { SocketContext } from "../utilities/socket";

export const useSocket = () => useContext(SocketContext);
